import Attack from './Attacks';
import TimeKeeper from '../engine/TimeKeeper';
import AircraftModel from '../aircraft/AircraftModel';
import _cloneDeep from 'lodash/cloneDeep';
import { ATTACK_SETTING_NAMES, GAME_ATTACK_TYPES } from '../constants/gameAttackConstants';
import AttackController from './AttackController';

class FalseHeadningAttack extends Attack {
    /**
     * @param {number} startTimestamp 
     * @param {number} realHeading
     */
    constructor(startTimestamp, realHeading) {
        super(startTimestamp);

        /**
         * The weight of heading change
         * 
         * @type {number}
         * @default 3
         * @private
         */
        this.headingDiff = AttackController.attackOptions.getAttackOptionByName(ATTACK_SETTING_NAMES.FALSE_HEADING_WEIGHT); 

        /**
         * The number of seconds between heading changes
         * 
         * @type {number}
         * @default 12
         * @private
         */
        this.headingRate = AttackController.attackOptions.getAttackOptionByName(ATTACK_SETTING_NAMES.FALSE_HEADING_RATE);

        /**
         * The real heading of the aircraft
         * 
         * @type {number}
         * @default null
         * @private
         */
        this.realHeading = null;

        /**
         * The time of the last heading change
         * 
         * @type {number}
         * @default null
         * @private
         */
        this.lastHeadingChange = 0;

        /**
         * Flag to indicate if the aircraft that has false heading attack is a copy
         * 
         * @type {boolean}
         * @default false
         * @private
         */
        this.isCopy = false;

        this.init(realHeading);
    }

    /**
     * Initialize the attack data
     * 
     * @param {number} realHeading - the heading of the aircraft
     */
    init(realHeading) {
        super.init();
        this.realHeading = realHeading;
    }

    /**
     * Updates the attack data for false heading attack
     * 
     * @param {AircraftModel} aircraft 
     */
    update(aircraft) {
        const currentTime = Math.floor(TimeKeeper.accumulatedDeltaTime);

        this.setHeadingDiff(AttackController.attackOptions.getAttackOptionByName(ATTACK_SETTING_NAMES.FALSE_HEADING_WEIGHT));
        this.setHeadingRate(AttackController.attackOptions.getAttackOptionByName(ATTACK_SETTING_NAMES.FALSE_HEADING_RATE));

        if (currentTime - this.lastHeadingChange >= this.headingRate) {
            aircraft.heading = this.realHeading + (Math.random() * 2 - 1) * this.headingDiff;
            this.lastHeadingChange = currentTime;
        } else if (currentTime - this.lastHeadingChange >= this.headingRate / 4) {
            aircraft.heading = this.realHeading;
        }
    }

    /**
     * Ends the attack
     * 
     * @param {number} endTimestamp 
     * @param {AircraftModel} aircaft 
     */
    end(endTimestamp, aircraft) {
        super.end(endTimestamp);
        aircraft.heading = this.realHeading;
    }

    getCopyToShowTrueTrack(aircraft) {
        /**
         * @type {AircraftModel}
         */
        let copy = _cloneDeep(aircraft);
        copy.heading = this.realHeading;
        copy.attackType = GAME_ATTACK_TYPES.REGULAR;
        copy.FalseHeadingAttack.isCopy = true;
        return copy;
    }

    setHeadingDiff(headingDiff) {
        this.headingDiff = headingDiff;
    }

    setHeadingRate(headingRate) {
        this.headingRate = headingRate;
    }

    getRealHeading() {
        return this.realHeading;
    }

    getIsCopy() {
        return this.isCopy;
    }
}

export default FalseHeadningAttack;